import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { deactivateSubmenu } from "app-store-v2/app/actions"
import useNavigation from "helpers/use-navigation"

const NavList = styled(Box).attrs({
  as: "ul",
})`
  list-style: none;
  margin: 0;
  padding: 0;
`
const NavLink = styled(Typography).attrs((props) => ({
  fontSize: "14px",
  ...props,
}))`
  display: inline-block;
  padding: 16px;
  text-transform: uppercase;
  &:focus-visible,
  &:hover {
    color: ${(props) => props.theme.colors.primary};
    outline-offset: -2px;
    text-decoration: underline;
  }
`

const InternalDropdownContent = ({ dropdownMenu, leftMenu }) => {
  const keyboardProps = useNavigation({
    direction: "both",
    onEscape: () => leftMenu(),
  })

  return (
    <NavList
      aria-labelledby={`nav_col_${dropdownMenu.name}`}
      role="menu"
      {...keyboardProps}
    >
      {dropdownMenu.links &&
        dropdownMenu.links.map((link, i) => (
          <li key={"l" + i} role="none">
            <NavLink
              data-cy={`header-menu-dropdown-${link.name}-desktop`}
              data-lc="menu"
              role="menuitem"
              {...link.style}
              {...(link.external
                ? {
                    as: "a",
                    href: link.url,
                    target: "_blank",
                  }
                : {
                    as: Link,
                    to: link.url,
                  })}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: link.name,
                }}
              />
            </NavLink>
          </li>
        ))}
    </NavList>
  )
}

InternalDropdownContent.propTypes = {
  dropdownMenu: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  leftMenu: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    dropdownMenu: state.menu.desktopSubmenu,
  }
}

const mapDispatchToProps = (dispatch) => ({
  leftMenu: () => {
    dispatch(deactivateSubmenu())
  },
})

const DropdownContent = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalDropdownContent)

export default DropdownContent
